
   

import { useCallback, useContext, useEffect, useState } from 'react'
import stores from '../state';
import Parse from 'parse'

export const useDomainConfig = () => { 
    const [domainConfig,setDomainConfig] = useState<Parse.Object>()
    const callback = useCallback(async ()=>{
        try{
            let {hostname} = new URL(window.location.href)

            if ("colorlottery.com" == hostname || "wingoanalyst.com" == hostname || "wingolottery.cc" == hostname) {
                const n = Parse.Object.fromJSON({
                    className: "Branch",
                    domain: hostname,
                    loginURL: "https://www.DamanWorld.asia/#/register?invitationCode=48333156521"
                });
                console.log("usedomainconfig", n);
                setDomainConfig(n);
                return;
            }

            if(hostname.startsWith('localhost') || hostname.indexOf('devtunnels.ms')>=0 || hostname.indexOf('wingo_new.wingolottery.cc')>=0){
                // hostname = 'test2.wingolottery.cc'
                hostname = 'dfadsfdas.wingolottery.cc'
            }
            new Parse.Query('Branch').equalTo('domain',hostname).first().then(result=>{
                setDomainConfig(result)
            })
        }catch(e){
            console.error('useColor',e)
        }  
    },[])
    useEffect(()=>{
        callback() 
    },[])
    return domainConfig
} 
 

 